const localization = function() {
    function getSupportedLanguages() {
        // https://en.wikipedia.org/wiki/List_of_ISO_639_language_codes
        return [
            { value: 'en', text: 'English' },
            { value: 'ar', text: 'اَلْعَرَبِيَّةُ (Arabic)' },
            { value: 'bg', text: 'Български (Bulgarian)' },
            { value: 'ca', text: 'Català (Catalan)' },
            { value: 'zh-Hans', text: '汉语 (Chinese (Simplified))' },
            { value: 'hr', text: 'Hrvatski (Croatian)' },
            { value: 'cs', text: 'Čeština (Czech)' },
            { value: 'da', text: 'Dansk (Danish)' },
            { value: 'nl', text: 'Nederlands (Dutch)' },
            { value: 'fi', text: 'Suomi (Finnish)' },
            { value: 'fr', text: 'Français (French)' },
            { value: 'de', text: 'Deutsch (German)' },
            { value: 'el', text: 'Νέα Ελληνικά (Greek)' },
            { value: 'he', text: 'עברית  (Hebrew)' },
            { value: 'hi', text: 'हिन्दी (Hindi)' },
            { value: 'hu', text: 'Magyar nyelv (Hunngarian)' },
            { value: 'id', text: 'bahasa Indonesia (Indonesian)' },
            { value: 'it', text: 'Italiano (Italian)' },
            { value: 'ja', text: '日本語 (Japanese)' },
            { value: 'ko', text: '한국어 (Korean)' },
            { value: 'ms', text: 'بهاس ملايو (Malay)' },
            { value: 'no', text: 'Norsk (Norwegian)' },
            { value: 'pl', text: 'Polski (Polish)' },
            { value: 'pt', text: 'Português (Portuguese)' },
            { value: 'ro', text: 'Românește (Romanian)' },
            { value: 'ru', text: 'Русский язык (Russian)' },
            { value: 'es', text: 'Español (Spanish)' },
            { value: 'sv', text: 'Svenska (Swedish)' },
            { value: 'th', text: 'ภาษาไทย (Thai)' },
            { value: 'tr', text: 'Türkçe (Turkish)' },
            { value: 'vi', text: 'tiếng Việt (Vietnamese)' }
        ];
    }
    return {
        /** Gets the localized text for a specific language */
        get: language => {
            return new Promise(resolve => {
                fetch(`dist/localization/localization.${language}.json`).then(response => {
                    response.json().then(json => {
                        resolve(json);
                    });
                });
            });
        },
        closeModal: () => {
            const overlay = document.getElementsByClassName('localization-overlay')[0];
            if (overlay) {
                const panel = document.getElementsByClassName('localization-panel')[0];
                document.getElementsByTagName('body')[0].removeChild(panel);
                document.getElementsByTagName('body')[0].removeChild(overlay);
            }
        },
        /** Shows the language selection modal */
        showModal: (propertyInfo) => {
            // Check if overlay already exists
            let overlay = document.getElementsByClassName('localization-overlay')[0];
            if (overlay) {
                return;
            }
            if (propertyInfo.tier === 1) {
                // Add the overlay (the black div that covers the entire screen)
                overlay = document.createElement('div');
                overlay.classList.add('localization-overlay');
                document.getElementsByTagName('body')[0].appendChild(overlay);
                const panel = document.createElement('div');
                panel.classList.add('localization-panel');
                panel.style.textAlign = "center";
                const message = document.createElement('div');
                message.innerHTML = 'Multi-language support is not available for this property. Please contact your host to enable it.<br /><br />';
                const closeButton = document.createElement('button');
                closeButton.classList.add('btn');
                closeButton.classList.add('btn-default');
                closeButton.innerText = 'OK';
                panel.appendChild(message);
                panel.appendChild(closeButton);
                document.getElementsByTagName('body')[0].appendChild(panel);
                closeButton.addEventListener('click', () => {
                    localization.closeModal();
                });
                return;
            }
            let selectedLanguage = "en";
            if (localStorage.getItem("language")) {
                selectedLanguage = localStorage.getItem("language");
            }
            localization.get(selectedLanguage).then(function (localizationText) {
                // Add the overlay (the black div that covers the entire screen)
                overlay = document.createElement('div');
                overlay.classList.add('localization-overlay');
                document.getElementsByTagName('body')[0].appendChild(overlay);
                // Add the main panel
                const panel = document.createElement('div');
                panel.classList.add('localization-panel');
                // Create child elements
                const header = document.createElement('div');
                header.innerText = localizationText.selectLanguage;
                const dropdown = document.createElement('select');
                dropdown.id = 'languageDropDown';
                dropdown.classList.add('form-control');
                dropdown.classList.add('margin-top-reg');
                // Add the supported languages
                const languages = getSupportedLanguages();
                for (let i = 0; i < languages.length; i++) {
                    const option = document.createElement('option');
                    option.value = languages[i].value;
                    option.innerText = languages[i].text;
                    dropdown.appendChild(option);
                }
                const button = document.createElement('button');
                button.id = 'selectBtn';
                button.classList.add('btn');
                button.classList.add('btn-success');
                button.classList.add('margin-top-reg');
                button.innerText = localizationText.select;
                // Append all the children to the main panel
                panel.appendChild(header);
                panel.appendChild(dropdown);
                panel.appendChild(button);
                document.getElementsByTagName('body')[0].appendChild(panel);
                // Event listeners
                document.getElementById('selectBtn').addEventListener('click', function () {
                    const selectedLanguage = document.getElementById('languageDropDown').value;
                    localStorage.setItem("language", selectedLanguage);
                    location.reload();
                });
            });
        },
        /** Translate other languages into English */
        getEnglishTranslation: (apiHost, languageCode, text) => {
            return new Promise(resolve => {
                if (languageCode === "en") {
                    return resolve(text);
                }
                fetch(`${apiHost}/api/private/translation`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({ languageCode: "en", text })
                }).then(resp => {
                    if (resp.status === 200) {
                        resp.json().then(data => {
                            resolve(data.translation);
                        }).catch(resp => {
                            console.error(resp);
                            resolve(text);
                        });
                    }
                    else {
                        console.error(resp);
                        resolve(text);
                    }
                }).catch(resp => {
                    console.error(resp);
                    resolve(text);
                });
            });
        }
    }
}();